import request from './index'

export function getShopList(params) {
  return request({
    url: '/shop/list',
    method: 'get',
    params
  })
}

export function getShopDetail(id) {
  return request({
    url: '/shop/' + id,
    method: 'get'
  })
}

export function createShop(data) {
  return request({
    url: '/shop',
    method: 'post',
    data
  })
}

export function updateShop(id, data) {
  return request({
    url: '/shop/' + id,
    method: 'put',
    data
  })
}

export function getShopAdmins(shopId) {
  return request({
    url: '/shop/' + shopId + '/admins',
    method: 'get'
  })
}

export function removeShopAdmin(shopId, userId) {
  return request({
    url: '/shop/' + shopId + '/admin/' + userId,
    method: 'delete'
  })
}

export function generateInvite(shopId) {
  return request({
    url: '/shop/admin/invite',
    method: 'post',
    data: { shopId }
  })
}

export function reviewAdmin(adminId, approved) {
  return request({
    url: '/shop/admin/review/' + adminId,
    method: 'put',
    data: { approved }
  })
}

export function toggleAdminStatus(adminId) {
  return request({
    url: '/shop/admin/toggle/' + adminId,
    method: 'put'
  })
}